<template>
  <div>
    <a-button type="primary" icon="plus-circle" @click="visible = true">添加分类</a-button>

    <!-- 表格 -->
    <a-table size="middle" row-key="id" :loading="loading" :data-source="data" :columns="columns" :indentSize="20" :pagination="false" style="margin-top: 20px" @change="handleTableChange">
      <template slot="operation" slot-scope="text, record">
        <a-button size="small" type="link" @click="handleTableCommand('add', record)">添加子类</a-button>
        <a-button size="small" type="link" @click="handleTableCommand('edit', record)">编辑</a-button>
        <a-button size="small" type="link" @click="handleTableCommand('delete', record)">删除</a-button>
      </template>
    </a-table>

    <!-- 添加分类 -->
    <a-modal v-model="visible" :title="title" :afterClose="handleCancel">
      <a-form :form="form" :label-col="{span: 5}" :wrapper-col="{span: 19}">
        <a-form-item label="上级分类">
          <a-cascader v-decorator="['cascader', { rules: [{ required: true, message: '请选择发布平台' }] }]" :fieldNames="{ label: 'type_name', value: 'id', children: 'children'}" :options="computedClassify" change-on-select placeholder="请选择" />
        </a-form-item>
        <a-form-item label="分类名称">
          <a-input v-decorator="['type_name', { rules: [{ required: true, message: '请填写分类名称', validator: typeNameValidator }] }]" placeholder="请输入" />
        </a-form-item>
        <a-form-item label="简写">
          <a-input v-decorator="['name']" placeholder="请输入" />
        </a-form-item>
        <a-form-item label="标题">
          <a-input v-decorator="['title']" placeholder="请输入" />
        </a-form-item>
        <a-form-item label="关键字">
          <a-input v-decorator="['keywords']" placeholder="请输入" />
        </a-form-item>
        <a-form-item label="描述">
          <a-input v-decorator="['description']" placeholder="请输入" />
        </a-form-item>
        <a-form-item label="官网是否显示">
          <a-radio-group name="radioGroup" v-decorator="['is_show', { initialValue: 1 }]">
            <a-radio v-for="item in ARTICLE_TYPE_IS_SHOW" :key="item.key" :value="item.key">{{ item.value }}</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="官网显示排序">
          <a-input v-decorator="['sort']" type="number" placeholder="请输入" />
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button key="back" @click="handleCancel">
          取 消
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">
          提 交
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { ref, reactive, onMounted, toRefs, getCurrentInstance, computed } from '@vue/composition-api'
import { strategyCommand, title } from './business/tableLogic'
import { columns } from './business/classifyList'
import { listClassifyTree, updateClassify, createClassify } from '@/api/article/classify'
import pagination from '@/composables/pagination'
import compuedFun from '../../computed/'
export default {
  setup(props) {
    // 获取当前实例
    const _this = getCurrentInstance()
    // 分页信息

    const computedClassify = computed(() => [{ id: 0, type_name: '作为一级分类' }].concat(_this.data))

    const state = reactive({
      btnLoading: false,
      columns,
      title: title.Add,
      form: _this.$form.createForm(_this)
    })

    onMounted(() => {
      methods.getList()
    })

    const methods = {
      // 获取列表
      async getList() {
        _this.loading = true
        const res = await listClassifyTree()
        const { articleType } = res.data
        _this.data = articleType
        _this.loading = false
      },

      // 提交编辑
      handleSubmit() {
        _this.form.validateFieldsAndScroll(async (err, vals) => {
          let res = null
          if (!err) {
            state.btnLoading = true
            if (_this.isEdit) {
              vals.parent = vals.cascader[vals.cascader.length - 1]
              const { id, line_id } = this.waitItem
              vals = Object.assign({}, vals, { id, line_id })
              res = await updateClassify(vals)
            } else {
              vals.parent = vals.cascader[vals.cascader.length - 1]
              res = await createClassify(vals)
            }
            if (_this.$validate(res)) {
              this.$message.success(_this.isEdit ? '编辑成功~' : '新增成功~')
              _this.visible = false
              this.getList()
            }
            state.btnLoading = false
          }
        })
      },

      // 验证分类名称
      typeNameValidator(rule, value, cb) {
        value = value.trim()
        if (!value) {
          return cb(new Error('不能为空'))
        }
        cb()
      },

      // 新增标签
      handleAddTag() {
        _this.visible = true
        _this.isEdit = false
        state.title = title.Add
      },

      // 关闭弹窗
      handleCancel() {
        state.form.resetFields()
        _this.visible = false
      },

      // 表格操作
      handleTableCommand(type, data) {
        strategyCommand[type].call(_this, data)
      }
    }
    return {
      ...toRefs(state),
      computedClassify,
      ...compuedFun(),
      ...pagination(),
      ...methods
    }
  }
}
</script>
<style lang='less'>
</style>
